/* f52ymm-header-bar.js - header announcement bar state */
(function () {
  'use strict';

  function getVehicle() {
    try {
      const s = sessionStorage.getItem('f52ymmVehicle');
      if (s) return JSON.parse(s);
    } catch {}

    try {
      const l = localStorage.getItem('f52ymm:selectedVehicle');
      if (l) return JSON.parse(l);
    } catch {}

    const h = document.getElementById('f52ymm-selector');
    if (h && h.dataset && (h.dataset.year || h.dataset.model)) {
      return {
        year: h.dataset.year || '',
        make: h.dataset.make || '',
        model: h.dataset.model || ''
      };
    }

    return null;
  }

  function getVehicleShortName(v) {
    if (!v) return '';
    const parts = [];
    if (v.year) parts.push(v.year);
    if (v.make) parts.push(v.make);
    if (v.model) parts.push(v.model);
    return parts.join(' ').trim();
  }

  function formatVehicleName(v) {
    const joined = getVehicleShortName(v);
    if (!joined) return '';
    return 'Fits your ' + joined;
  }

  function updateHeaderBar() {
    const bar = document.getElementById('f52ymm-header-bar');
    if (!bar) return;

    const selectedLabel = bar.querySelector('.f52ymm-announcement-label-selected');
    const verifyBtn = bar.querySelector('.f52ymm-announcement-button');

    const vehicle = getVehicle();
    const hasVehicle = !!vehicle && (vehicle.year || vehicle.make || vehicle.model);

    if (hasVehicle) {
      bar.classList.remove('f52ymm-announcement-empty');
      bar.classList.add('f52ymm-announcement-selected');

      if (selectedLabel) {
        selectedLabel.textContent = formatVehicleName(vehicle);
      }

      if (verifyBtn) {
        // Show vehicle name in the CTA instead of "Change vehicle"
        const shortName = getVehicleShortName(vehicle);
        verifyBtn.textContent = shortName || 'Change vehicle';
      }
    } else {
      bar.classList.add('f52ymm-announcement-empty');
      bar.classList.remove('f52ymm-announcement-selected');

      if (selectedLabel) {
        selectedLabel.textContent = '';
      }
      if (verifyBtn) {
        verifyBtn.textContent = 'Verify vehicle';
      }
    }
  }

  function clearVehicle() {
    // Prefer the core YMM clear so all states stay in sync
    if (window.f52Ymm && typeof window.f52Ymm.clearSelectedVehicle === 'function') {
      window.f52Ymm.clearSelectedVehicle();
    } else {
      console.warn('[YMM header bar] clearSelectedVehicle unavailable, using fallback');

      // Fallback: clear stored vehicle
      try {
        sessionStorage.removeItem('f52ymmVehicle');
      } catch {}
      try {
        localStorage.removeItem('f52ymm:selectedVehicle');
      } catch {}

      // Clear header selector dataset fallback
      const h = document.getElementById('f52ymm-selector');
      if (h && h.dataset) {
        h.dataset.year = '';
        h.dataset.make = '';
        h.dataset.model = '';
        if ('makeId' in h.dataset) h.dataset.makeId = '';
        if ('modelId' in h.dataset) h.dataset.modelId = '';
      }

      // Tell other YMM scripts the vehicle is gone
      document.dispatchEvent(new Event('f52ymm:vehicleCleared'));
    }

    // Update this bar immediately (no hard reload)
    updateHeaderBar();
  }

  document.addEventListener('DOMContentLoaded', function () {
    updateHeaderBar();
  });

  document.addEventListener('f52ymm:vehicleSaved', updateHeaderBar);
  document.addEventListener('f52ymm:vehicleRestored', updateHeaderBar);
  document.addEventListener('f52ymm:vehicleCleared', updateHeaderBar);

  document.addEventListener('click', function (evt) {
    const btn = evt.target.closest('.f52ymm-announcement-clear');
    if (btn) clearVehicle();
  });
})();
